/**
 * @license
 * Copyright 2025 Google LLC
 * Copyright 2025 Hayate Esaki
 * SPDX-License-Identifier: Apache-2.0
 *
 * Based on original work by Google LLC (2025)
 * Modified and extended by Hayate Esaki (2025)
 */

export const DEFAULT_DIFF_OPTIONS: {
  context: number;
  ignoreWhitespace: boolean;
} = {
  context: 3,
  ignoreWhitespace: true,
};
